import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ categoryId = '', ...params }) => {
  return await dponetAPI.get(
    `/complaint_categories/${categoryId}/complaint_sub_categories`,
    { params },
  )
}

const create = async ({ categoryId = '', ...data }) => {
  return await dponetAPI.post(
    `/complaint_categories/${categoryId}/complaint_sub_categories`,
    data,
  )
}

const update = async ({ categoryId = '', subCategoryId = '', ...data }) => {
  return await dponetAPI.put(
    `/complaint_categories/${categoryId}/complaint_sub_categories/${subCategoryId}`,
    data,
  )
}

const registerResponsibles = async ({
  categoryId = '',
  subCategoryId = '',
  ...data
}) => {
  return await dponetAPI.put(
    `/complaint_categories/${categoryId}/complaint_sub_categories/${subCategoryId}/responsibles`,
    data,
  )
}

const complaintSubCategories = {
  get,
  create,
  update,
  registerResponsibles,
}

export default complaintSubCategories
